

















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Cards extends Vue {
  @Prop({ default: 'var(--card-default-per-row)' })
  public readonly perRow!: number;

  @Prop({ default: 'var(--card-default-spacing)' })
  public readonly spacing!: string;

  @Prop({ default: 'var(--card-md-default-per-row)' })
  public readonly mdPerRow!: number;

  @Prop({ default: 'var(--card-sm-default-per-row)' })
  public readonly smPerRow!: number;

  @Prop({ default: 'var(--card-xs-default-per-row)' })
  public readonly xsPerRow!: number;

  @Prop({ default: 'center' })
  public readonly hAlign!: string;

  @Prop({ default: 'stretch' })
  public readonly vAlign!: string;
}
